import { render, staticRenderFns } from "./redemptionPlan.vue?vue&type=template&id=36ea7a1a&"
import script from "./redemptionPlan.vue?vue&type=script&lang=js&"
export * from "./redemptionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports